export default __webpack_public_path__ + "static/media/Mark-2-HUD-Radar.05019035.jpg";